<template>
  <div id="orderList">
    <div class="head-status-box">
      <el-row :gutter="20">
        <el-col :span="4">
          <div
            @click="setStatus(0)"
            :class="checkStatus == 0?'status-button-click':''"
            class="status-button"
          >{{headStatusButton[0]}}</div>
        </el-col>
        <el-col
          :span="3"
          v-for="(item,index) in headStatusButton"
          v-show="item != '' && index != 0"
          :key="index"
        >
          <div
            @click="setStatus(index)"
            :class="checkStatus == index?'status-button-click':''"
            class="status-button"
          >{{item}}</div>
        </el-col>
      </el-row>
    </div>
    <div class="head-search-box">
      <div class="search-title">
        <span style="margin-left:16px">筛选查询</span>
        <div class="search-button" @click="searchOrder">搜 索</div>
      </div>
      <div class="search-input">
        <el-row :gutter="20">
          <el-col :span="7" style="margin-left:16px;">
            <div class="input-box">
              <span style="width:95px;margin-right:10px;">请输入搜索 :</span>
              <el-input
                style="width:200px"
                clearable
                v-model="searchForm.orderCode"
                placeholder="请输入订单编号"
              ></el-input>
            </div>
          </el-col>
          <el-col :span="10">
            <div class="input-box">
              <span style="width:90px;">提交时间 :</span>
              <el-date-picker
                v-model="searchForm.timeValue"
                value-format="timestamp"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
            </div>
          </el-col>
          <el-col :span="2">
             <div class="label">是否结算</div>
            </el-col>
            <el-col :span="4">
              <el-select v-model="is_share" size="small" clearable  filterable placeholder="请选择">
                <el-option
                  v-for="item in options2"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-col>
          
        </el-row>
      </div>
      <div class="table-box">
        <div class="table-head">
          <div style="margin-left:13px;">
            <i class="iconfont icon-liebiao" style="color:#666666"></i> 数据列表
          </div>
          <div style="width:134px;margin-right:21px;">
            <el-select v-model="limit" size="small" @change="limitChange()">
              <el-option
                v-for="(item,index) in showLimit"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="table">
          <template>
            <el-table
              :header-cell-style="{
                'background-color': '#F5FAF9'
                }"
              :data="tableData"
              border
              v-loading="loading"
              style="width: 100%"
            >
              <el-table-column align="center" prop="orderCode" label="订单编号" width="185">
                <template slot-scope="scope">
                  <router-link
                    target="_blank"
                    :to="'./orderInfo/' + scope.row.id "
                    style="text-decoration: none;"
                  >
                    <el-link>{{scope.row.orderCode}}</el-link>
                  </router-link>
                </template>
              </el-table-column>
              <el-table-column align="center" prop="create_time" label="订货日期" width="100"></el-table-column>
              <el-table-column align="center" prop="link_name" label="订货人"></el-table-column>
              <el-table-column align="center" prop="pay_money" label="总金额"></el-table-column>
              <el-table-column align="center" prop="note" label="客户留言" show-overflow-tooltip></el-table-column>
              <el-table-column align="center" prop="status" label="订单状态">
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.status == 0" color size="small">待付款</el-tag>
                  <el-tag v-else-if="scope.row.status == 2 || scope.row.status == 1" color type="warning" size="small">待发货</el-tag>
                  <el-tag v-else-if="scope.row.status == 3" color size="small">待收货</el-tag>
                  <el-tag v-else-if="scope.row.status == 4" color size="small">待评价</el-tag>
                  <el-tag v-else-if="scope.row.status == 5" color type="success" size="small">已完成</el-tag>
                  <el-tag v-else-if="scope.row.status == 6" color size="small">已取消</el-tag>
                </template>
              </el-table-column>
              <el-table-column width="80" label="平台结算" align="center">
                <template slot-scope="scope">
                    <el-tag  v-if="scope.row.is_share == 1" size="small" type="success">已结算</el-tag>
                    <el-tag v-else-if="scope.row.is_share == 2" size="small" type="danger">已作废</el-tag>
                    <el-tag type="info" size="small" v-else>未结算</el-tag>
                  </template>   
              </el-table-column>
              <el-table-column align="center" prop="shop_remark" label="备注" show-overflow-tooltip></el-table-column>
              <el-table-column align="center" label="操作">
                <template slot-scope="scope">
                  <!-- <el-link
                    v-if="scope.row.status == 0"
                    @click="showAlertMessage = true,alertMessageIndex = scope.$index,alertString()"
                  >提醒付款</el-link> -->
                  <el-link
                    v-if="scope.row.status == 2 || scope.row.status == 1"
                    @click="showShipment = true,shipmentId = scope.row.id"
                  >确认发货</el-link> 

                  <router-link
                    v-else
                    target="_blank"
                    :to="'./orderInfo/' + scope.row.id "
                    style="text-decoration: none;"
                  >
                    <el-link>查看</el-link>
                  </router-link>
                  <el-link
                    @click="ordernote = true,submitNote(scope.row.shop_pay_status,scope.row.note,scope.row.orderCode)"
                  > 备注</el-link> 
                </template>
              </el-table-column>
            </el-table>
            <div class="page-box" v-show="pageTotal > limit">
              <div style="margin-top:7px">
                <el-pagination
                  hide-on-single-page
                  background
                  layout="total,prev, pager, next"
                  :total="pageTotal"
                  :page-size="limit"
                  @current-change="setPage"
                ></el-pagination>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div>
      <el-dialog title="发货信息" :visible.sync="showShipment" width="800px">
        <el-form :model="shipmentForm">
          <el-form-item label="快递单号 :" label-width="100px">
            <el-input v-model="shipmentForm.expressCode" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="快递公司 :" label-width="100px">
            <el-select v-model="shipmentForm.expressCom" placeholder="请选择快递公司">
              <el-option
                v-for="item in expressList"
                :key="item.id"
                :label="item.com_name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="showShipment = false">取 消</el-button>
          <el-button type="primary" @click="submitShipment">确 定</el-button>
        </div>
      </el-dialog>
    </div>
    <div>
      <el-dialog title="提醒内容" :visible.sync="showAlertMessage" width="800px">
        <span>{{showAlertStr}}</span>
        <div slot="footer" class="dialog-footer">
          <el-button @click="showAlertMessage = false">取 消</el-button>
          <el-button type="primary" @click="submitAlert()">确 定</el-button>
        </div>
      </el-dialog>
    </div>
    <div>
      <el-dialog title="备注" :visible.sync="ordernote" width="800px">
        <el-form>
          <el-form-item label="付款方式 :" label-width="100px">
             <el-select v-model="shop_pay_status" clearable placeholder="请选择支付方式">
              <el-option
                v-for="item in payways"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注: " label-width="100px">
            <el-input type="textarea" v-model="note" clearable></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="ordernote = false">取 消</el-button>
          <el-button type="primary" @click="submitNote2()">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      serve: this.$store.state.serve,
      token: this.$cookies.get("shop_token"),
      headStatusButton: [
        "全部订单",
        "待付款",
        "",
        "待发货",
        "待收货",
        "待评价",
        "已完成",
        "已取消"
      ],
      count0: 0,
      count1: 0, //未付款
      count2: 0, //待采购
      count3: 0, //待发货
      count4: 0, //已发货
      count5: 0, //待评价
      count6: 0, //已完成
      count7: 0, //取消
      checkStatus: "",
      status: this.$route.query.status ? this.$route.query.status : "",
      showLimit: [
        { label: "每页10条", value: 10 },
        { label: "每页15条", value: 15 },
        { label: "每页20条", value: 20 },
        { label: "每页50条", value: 50 }
      ],
      limit: 15,
      searchForm: {
        orderCode: "",
        timeValue: ""
      },
      tableData: [],
      pageTotal: 0,
      page: 0,
      expressList: [],
      showShipment: false,
      shipmentForm: {},
      shipmentId: "",
      showAlertMessage: false,
      alertMessageIndex: "",
      showAlertStr: "",
      ordernote: false,
      orderCode: '',
      payways: [{
         id: 0,
         name: '未支付'
      },{
         id: 1,
         name: '微信'
      },{
         id: 2,
         name: '支付宝'
      },{
         id: 3,
         name: '银行卡'
      },{
         id: 4,
         name: '其他'
      }],
      shop_pay_status: 0,
      note: '',
      options2:[
        {
          id:0,
          name: '未结算'
        },{
          id:1,
          name: '已结算'
        },{
          id:2,
          name: '已作废'
        },
      ],
      is_share: 0
    };
  },
  created() {
    this.$store.state.shop_top = 2;
    this.$store.state.shop_left = "订单列表";

    if (this.$route.query.status) {
      if (this.$route.query.status == 0) {
        this.checkStatus = 1;
      } else if (this.$route.query.status == 2) {
        this.checkStatus = 3;
      }
    }
    this.getList();
    this.getExpressList();
  },
  methods: {
    submitNote (shop_pay_status = 0,note='',orderCode = '') {
     
      var shop_pay_status = shop_pay_status == null ? 0 : shop_pay_status; 
      this.shop_pay_status = this.payways[shop_pay_status].name;
      this.note = note;
      this.orderCode = orderCode
    },
    submitNote2 () {
      var where = {
        token: this.token,
        orderCode: this.orderCode,
        shop_pay_status: this.shop_pay_status,
        note: this.note
      };
      this.axios
      .get(this.serve + "shop/makeNote", { params: where })
      .then(res => {
        var data = res.data;
        if(data.status == 'success'){
          this.$message.success(data.msg);
          this.ordernote = false;
          window.location.reload();
        }
      });
    },
    submitAlert() {
      var orderCode = this.tableData[this.alertMessageIndex].orderCode;
      var where = {
        token: this.token,
        orderCode: orderCode
      };
      this.axios
        .get(this.serve + "shop/alertPay", { params: where })
        .then(res => {
          var data = res.data;
          if (data.status == "success") {
            this.$alerts.success("短信发送成功", this.$message);
            this.showAlertMessage = false;
          } else {
            this.$alerts.error("短信发送失败", this.$message);
          }
        });
    },
    alertString() {
      var orderCode = this.tableData[this.alertMessageIndex].orderCode;
      var endTime = this.tableData[this.alertMessageIndex].end_time;
      this.showAlertStr =
        "您好,您的订单编号" +
        orderCode +
        "为的订单即将过期,过期时间为" +
        endTime;
    },
    submitShipment() {
      var where = this.shipmentForm;
      if (!where.expressCode) {
        this.$alerts.error("订单编号为必填选项", this.$message);
        return;
      }
      if (!where.expressCom) {
        this.$alerts.error("快递公司为必填选项", this.$message);
        return;
      }
      where.token = this.token;
      where.orderId = this.shipmentId;
      this.axios
        .get(this.serve + "shop/shipments", { params: where })
        .then(res => {
          var data = res.data;
          if (data.status == "success") {
            this.$alerts.success("发货成功", this.$message);
            this.showShipment = false;
            this.expressForm = {};
            this.getList();
          } else {
            this.$alerts.error("发货失败,检查信息后重新发货", this.$message);
          }
        });
    },
    getExpressList() {
      var where = {
        token: this.token
      };
      this.axios
        .get(this.serve + "shop/getExpressList", { params: where })
        .then(res => {
          var data = res.data;
          if (data.status == "success") {
            this.expressList = data.data.results;
          } else {
            this.expressList = [];
          }
        });
    },
    setPage(page) {
      this.page = page;
      this.getList();
    },
    limitChange() {
      this.getList();
    },
    setStatus(index) {
      this.checkStatus = index;
      this.page = 0;
      this.pageTotal = 0;
      switch (index) {
        case 0:
          this.status = "";
          break;
        case 1:
          this.status = 0;
          break;
        case 2:
          this.status = 1;
          break;
        case 3:
          this.status = 2;
          break;
        case 4:
          this.status = 3;
          break;
        case 5:
          this.status = 4;
          break;
        case 6:
          this.status = 5;
          break;
        case 7:
          this.status = 6;
          break;
      }
      this.getList();
    },
    searchOrder() {
      this.getList();
    },
    getList() {
      // const loading = this.$loading({
      //   lock: true,
      //   text: '正在加载...',
      //   spinner: 'el-icon-loading',
      //   background: 'rgba(0, 0, 0, 0.7)'
      // })
      // setTimeout(() => {
      //   loading.close()
      // }, 5000)
      this.loading = true;
      var where = {
        token: this.token,
        status: this.status,
        limit: this.limit,
        page: this.page != 0 ? this.page : "",
        searchForm: this.searchForm,
        is_share:this.is_share
      };
      this.axios
        .get(this.serve + "shop/orderList", { params: where })
        .then(res => {
          var data = res.data;console.log(data.data);
          // var count = res.data.data;
          // this.count0 = count.all_num;
          // this.count1 = count.num_0;
          // this.count2 = count.num_1;
          // this.count3 = count.num_2;
          // this.count4 = count.num_3;
          // this.count5 = count.num_4;
          // this.count6 = count.num_5;
          // this.count7 = count.num_6;
          if (data.status == "success") {
            var tableData = data.data.results;
            //--------------
            var tabArr = [];
            tableData.forEach(v => {
               tabArr.push({address:v.address,create_time:v.create_time,end_time:v.end_time,id:v.id,is_share:v.is_share,link_name:v.link_name,note:v.note,orderCode:v.orderCode,pay_money:v.pay_money,shop_pay_status:v.shop_pay_status,shop_remark:v.shop_remark,status:v.status,product_list:JSON.parse(v.product_list)});
            });
            console.log(tabArr);
            //---------------
            this.tableData = tabArr;
            this.pageTotal = data.data.total;
          } else {
            this.tableData = [];
          }
          // loading.close()
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="scss">
#orderList {
  .head-status-box {
    width: 1060px;
    height: 36px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 300;
    color: rgba(51, 51, 51, 1);
    display: flex;
    .status-button {
      cursor: pointer;
      min-width: 100px;
      height: 34px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      line-height: 34px;
      text-align: center;
    }
    .status-button:hover {
      background: rgba(0, 153, 255, 1);
      color: rgba(255, 255, 255, 1);
      border: 1px solid rgba(221, 221, 221, 1);
    }
    .status-button-click {
      min-width: 100px;
      height: 34px;
      background: rgba(0, 153, 255, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      color: rgba(255, 255, 255, 1);
      line-height: 34px;
      text-align: center;
    }
    .el-row {
      width: 1060px;
    }
  }
  .head-search-box {
    margin-top: 20px;
    .search-title {
      width: 1060px;
      height: 46px;
      background: rgba(238, 238, 238, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      line-height: 46px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .search-button {
        line-height: 28px;
        text-align: center;
        width: 74px;
        height: 28px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(221, 221, 221, 1);
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 300;
        color: rgba(102, 102, 102, 1);
        margin-right: 21px;
        cursor: pointer;
      }
      .search-button:hover {
        background: rgba(0, 153, 255, 1);
        border: 1px solid rgba(221, 221, 221, 1);
        color: rgba(255, 255, 255, 1);
      }
    }
    .search-input {
      width: 1060px;
      height: 86px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      line-height: 86px;
      .input-box {
        display: flex;
        align-items: center;
      }
    }
  }
  .table-box {
    margin-top: 19px;
    margin-bottom: 100px;
    .table-head {
      width: 1060px;
      height: 46px;
      background: rgba(238, 238, 238, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .table {
      width: 1062px;
    }
    .page-box {
      border-left: 1px solid rgba(221, 221, 221, 1);
      border-right: 1px solid rgba(221, 221, 221, 1);
      border-bottom: 1px solid rgba(221, 221, 221, 1);
      height: 60px;
      display: flex;
      justify-content: flex-end;
    }
  }
}
.el-table .cell a{
   margin-right: 5px;
}
</style>